module.exports = __webpack_public_path__ + "img/user.51ac150e.svg";